export default function htmlId(id: string) {
  return `#${id}`;
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'html-id': typeof htmlId;
  }
}
